<template>
  <div class="ui-form-divider" role="separator" :aria-label="$t(title)">
    <div class="ui-form-divider__heading">
      <i v-if="icon" :class="['ui-form-divider__icon', icon]" aria-hidden="true"></i>
      <i v-else class="ui-form-divider__marker" aria-hidden="true"></i>
      <strong>{{ $t(title) }}</strong>
      <small v-if="description">{{ $t(description) }}</small>
    </div>
    <span class="ui-form-divider__line" aria-hidden="true"></span>
  </div>
</template>

<script>
export default {
  name: 'UiFormDivider',
  props: {
    title: { type: String, required: true },
    description: { type: String, default: '' },
    icon: { type: [String, Array, Object], default: '' }
  }
}
</script>

<style lang="scss" scoped>
.ui-form-divider {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: var(--ui-space-md);
  margin: var(--ui-space-lg) 0;
}

.ui-form-divider:not(:first-child) {
  margin-top: calc(var(--ui-space-lg) * 2);
}

.ui-form-divider__heading {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: var(--ui-space-sm);
  white-space: nowrap;
}

.ui-form-divider__marker {
  width: 2px;
  height: 14px;
  flex: none;
  border-radius: 1px;
  background: var(--ui-color-primary);
}

.ui-form-divider__icon {
  flex: none;
  color: var(--ui-color-primary);
  font-size: 14px;
  font-weight: 400;
}

.ui-form-divider__heading > strong {
  color: var(--ui-text-primary);
  font-size: var(--ui-font-size-body);
  font-weight: var(--ui-font-weight-bold);
  line-height: 20px;
}

.ui-form-divider__heading > small {
  overflow: hidden;
  color: var(--ui-text-secondary);
  font-size: var(--ui-font-size-caption);
  font-weight: var(--ui-font-weight-regular);
  line-height: 20px;
  text-overflow: ellipsis;
}

.ui-form-divider__line {
  height: 0;
  flex: 1;
  border-top: 1px solid var(--ui-border-color-subtle);
}

@media (max-width: 768px) {
  .ui-form-divider__heading > small { display: none; }
}
</style>
